var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8661 19.9331C13.8661 20.4117 13.4781 20.7997 12.9995 20.7997C12.5209 20.7997 12.1328 20.4117 12.1328 19.9331C12.1328 19.4545 12.5209 19.0664 12.9995 19.0664C13.4781 19.0664 13.8661 19.4545 13.8661 19.9331Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C5.82499 0 0 5.82499 0 13C0 20.175 5.82499 26 13 26C20.175 26 26 20.175 26 13C26 5.82499 20.175 0 13 0ZM13 1.73333C19.2182 1.73333 24.2667 6.78179 24.2667 13C24.2667 19.2182 19.2182 24.2667 13 24.2667C6.78179 24.2667 1.73333 19.2182 1.73333 13C1.73333 6.78179 6.78179 1.73333 13 1.73333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6013 9.53402C15.6013 10.2682 15.1862 10.9389 14.5302 11.2674C13.062 12.0015 12.1346 13.5015 12.1346 15.1432V16.4674C12.1346 16.9458 12.5229 17.334 13.0013 17.334C13.4797 17.334 13.868 16.9458 13.868 16.4674V15.1432C13.868 14.1585 14.4243 13.2582 15.305 12.8179C16.5486 12.1956 17.3346 10.9249 17.3346 9.53402C17.3346 7.14197 15.3934 5.20068 13.0013 5.20068C10.6093 5.20068 8.66797 7.14197 8.66797 9.53402C8.66797 10.0124 9.05623 10.4007 9.53464 10.4007C10.013 10.4007 10.4013 10.0124 10.4013 9.53402C10.4013 8.09882 11.5661 6.93402 13.0013 6.93402C14.4365 6.93402 15.6013 8.09882 15.6013 9.53402Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/Help_icon.4c396e632a77f78e22ea70f94874b817.svg";
export { ForwardRef as ReactComponent };